import Toaster from '@meforma/vue-toaster'

export default defineNuxtPlugin((nuxtApp) => {
  const configs = {
    position: 'bottom-left',
    useDefaultCss: true,
    duration: 5000,
  }
  nuxtApp.vueApp.use(Toaster, configs)
  return {
    provide: {
      toast: nuxtApp.vueApp.config.globalProperties.$toast,
    }
  }
})
